import { memo } from "react";

import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { AccessResult } from "utils/access";

import useDiscardRun from "./useDiscardRun";

type WorkerPoolQueuedRunsListItemDropdownProps = {
  runId: string;
  stackId: string;
  isPrioritized: boolean;
  setPriority: (isPrioritized: boolean) => () => void;
  isPublic?: boolean;
  canDiscard: AccessResult;
  canPrioritize: AccessResult;
};

const WorkerPoolQueuedRunsListItemDropdown = ({
  stackId,
  runId,
  isPrioritized,
  setPriority,
  isPublic,
  canDiscard,
  canPrioritize,
}: WorkerPoolQueuedRunsListItemDropdownProps) => {
  const { discardRun, discarding } = useDiscardRun();

  const handleSetPriority = (isPrioritized: boolean) => () => {
    setPriority(isPrioritized)();
  };

  const handleDiscardRun = () => discardRun(stackId, runId);

  const showPrioritize =
    !isPublic && !isPrioritized && (canPrioritize.result || !!canPrioritize.message);
  const showDePrioritize =
    !isPublic && isPrioritized && (canPrioritize.result || !!canPrioritize.message);
  const showDiscard = canDiscard.result || !!canDiscard.message;

  if (!showPrioritize && !showDePrioritize && !showDiscard) {
    return null;
  }

  return (
    <DropdownMenuEllipsis tooltip="Run actions">
      {showPrioritize && (
        <DropdownMenuItem
          isDisabled={!canPrioritize.result}
          tooltip={canPrioritize.message}
          onAction={handleSetPriority(true)}
        >
          Prioritize
        </DropdownMenuItem>
      )}
      {showDePrioritize && (
        <DropdownMenuItem
          isDisabled={!canPrioritize.result}
          tooltip={canPrioritize.message}
          onAction={handleSetPriority(false)}
        >
          De-prioritize
        </DropdownMenuItem>
      )}
      {showDiscard && (
        <DropdownMenuItem
          isDisabled={!canDiscard.result}
          tooltip={canDiscard.message}
          onAction={handleDiscardRun}
          loading={discarding}
        >
          Discard
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default memo(WorkerPoolQueuedRunsListItemDropdown);
